<h6 class="d-inline" *ngIf="qty !== 0">
  <span class="badge badge-danger" style="font-size: 1em; border-radius: 100%; padding: .15em .5em;">{{ qty }}</span>
</h6>
